/**
 * Design system transition utilities.
 *
 * Timing tiers:
 *   fast     = 100ms  (buttons, icon-buttons, micro-interactions)
 *   standard = 200ms  (hover states, card transitions, form fields)
 *   slow     = 300ms  (expanding sections, search bars, layout shifts)
 *   slowest  = 500ms  (side panels animating in, modal entrances)
 */

import { Property } from 'csstype';

type TransitionProperty = Property.TransitionProperty;

const EASING = 'ease-in-out';

export const transitionFast = (...properties: TransitionProperty[]) => {
  return properties.map((p) => `${p} 100ms ${EASING}`).join(', ');
};

export const transitionStandard = (...properties: TransitionProperty[]) => {
  return properties.map((p) => `${p} 200ms ${EASING}`).join(', ');
};

export const transitionSlow = (...properties: TransitionProperty[]) => {
  return properties.map((p) => `${p} 300ms ${EASING}`).join(', ');
};

export const transitionSlowest = (...properties: TransitionProperty[]) => {
  return properties.map((p) => `${p} 500ms ${EASING}`).join(', ');
};
